import React, { useEffect } from "react";

const TranslationErrorDetector = () => {
  useEffect(() => {
    if (NODE_ENV === "development") {
      if (typeof Node === "function" && Node.prototype) {
        function highlightElement(element) {
          if (element && element.style) {
            element.style.border = "2px solid red";
            element.style.backgroundColor = "rgba(255, 0, 0, 0.1)";
          }
        }

        const originalRemoveChild = Node.prototype.removeChild;
        Node.prototype.removeChild = function (child) {
          if (child.parentNode !== this) {
            console.log("Cannot remove a child from a different parent", child, this);
            highlightElement(child);
            highlightElement(this);
            return child;
          }
          return originalRemoveChild.apply(this, arguments);
        };

        const originalInsertBefore = Node.prototype.insertBefore;
        Node.prototype.insertBefore = function (newNode, referenceNode) {
          if (referenceNode && referenceNode.parentNode !== this) {
            highlightElement(newNode);
            highlightElement(this);
            if (console) {
              console.error(
                "Cannot insert before a reference node from a different parent",
                referenceNode,
                this,
              );
            }
            return newNode;
          }
          return originalInsertBefore.apply(this, arguments);
        };
      }
    }
  }, []);

  return null;
};

export default TranslationErrorDetector;
